import { render, staticRenderFns } from "./TrainingLayout.vue?vue&type=template&id=601093fb&scoped=true"
import script from "./TrainingLayout.vue?vue&type=script&lang=ts"
export * from "./TrainingLayout.vue?vue&type=script&lang=ts"
import style0 from "./TrainingLayout.vue?vue&type=style&index=0&id=601093fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601093fb",
  null
  
)

export default component.exports